import React, { useEffect } from 'react';
import { Dimmer, Loader, Table, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { getAccessLogs, gettingAccessLogsAction } from 'state/access/actions';

const AccessLogs = props => {
  const { dispatch, accessLogs, gettingAccessLogs, creatingUser } = props;
  const { data } = accessLogs;
  let accessLogsData = [];
  if (data) accessLogsData = data.internal_tools_activities;

  const handleOnScroll = e => {
    const currY = e.target.scrollTop;
    const maxY = e.target.scrollHeight - e.target.offsetHeight;
    const { paging } = accessLogs;

    if (currY >= maxY && data.internal_tools_activities.length < paging.total) {
      const newPage = paging.page + 1;
      const pageSize = 20;

      const payloadAccessLogs = {
        currState: accessLogs,
        requestMetadata: {
          group: 'access',
          item: '',
          page: newPage,
          size: pageSize,
        },
      };
      dispatch(gettingAccessLogsAction(true));
      dispatch(getAccessLogs(payloadAccessLogs));
    }
  };

  const formatAccessLogTime = dateTime =>
    format(new Date(dateTime), 'yyyy-MM-dd pp');

  useEffect(() => {
    if (gettingAccessLogs) dispatch(gettingAccessLogsAction(false));
  }, [accessLogs, dispatch, gettingAccessLogs]);

  useEffect(() => {
    if (creatingUser) {
      const payloadAccessLogs = {
        currState: {},
        requestMetadata: {
          group: 'access',
          item: '',
          page: 1,
          size: 20,
        },
      };
      dispatch(gettingAccessLogsAction(true));
      dispatch(getAccessLogs(payloadAccessLogs));
    }
  }, [creatingUser, dispatch]);

  return (
    <>
      <h3>Access Logs</h3>
      <Segment style={{ padding: '0px' }}>
        <div
          style={{ height: '290px', overflowY: 'scroll' }}
          onScroll={handleOnScroll}
        >
          <Dimmer active={gettingAccessLogs}>
            <Loader>Loading</Loader>
          </Dimmer>
          <Table celled selectable style={{ margin: '0px' }}>
            <Table.Header style={{ position: 'sticky', top: '0px' }}>
              <Table.Row>
                <Table.HeaderCell>Time</Table.HeaderCell>
                <Table.HeaderCell>Log</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {data ? (
                <>
                  {accessLogsData.map(accessLog => (
                    <Table.Row key={accessLog.id}>
                      <Table.Cell key={accessLog.time} width={2}>
                        {formatAccessLogTime(accessLog.time)}
                      </Table.Cell>
                      <Table.Cell key={accessLog.log}>
                        {(() => {
                          const log = accessLog.log.split('|');
                          return log.join(' | ');
                        })()}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </>
              ) : (
                <></>
              )}
            </Table.Body>
          </Table>
        </div>
      </Segment>
    </>
  );
};

const mapStateToProps = ({ access }) => ({
  accessLogs: access.accessLogs,
  gettingAccessLogs: access.gettingAccessLogs,
  creatingUser: access.creatingUser,
});

AccessLogs.propTypes = {
  dispatch: PropTypes.func.isRequired,
  accessLogs: PropTypes.object.isRequired,
  gettingAccessLogs: PropTypes.bool.isRequired,
  creatingUser: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(AccessLogs);
